import WebServiceRequest from "../../../Api/WebServiceRequest";

class updateAPhysicalCategoryProperty extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PhysicalCategoryProperty/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default updateAPhysicalCategoryProperty;
